/* eslint-disable no-unused-vars */
import React from 'react';
import "./MixingProcess.css";
import { useTranslation } from 'react-i18next';

function MixingProcess() {
  const { t } = useTranslation();
  return (
    <div className='mixingprocess-container'>
      <div className="mixingprocess-content">

        <div className='mixingprocess-header'>
          <h3>{t('nav_technologies_mixingprocess')}</h3>
        </div>
        <div className='pro-text-promotion'>
          <p>{t('techno-mixingprocess-p-text-one')}</p>
          <p>{t('techno-mixingprocess-p-text-two')}</p>
          <p>{t('techno-mixingprocess-p-text-three')}</p>
          <p>{t('techno-mixingprocess-p-text-four')}</p>
        </div>


      </div>
    </div>
  )
}

export default MixingProcess